module.exports = __webpack_public_path__ + "img/icon-energy.4dcaa5d1.svg";